import { webxError, webxErrorType, hongKongHostMap } from '@didi/webx-js-core';
import { getBranch } from '../initSDK';
import { query, parseURL } from '../query';
import { parseUserAgent, is as baseIs, xenv as baseXenv } from '@didi/webx-js-xenv';
/**
 * 检测当前环境,用于直接检测当前环境是否符合对应字符串。
 * @param strs 所需要判断的环境str。可判断的环境取值参考文档，"."代表并，","代表或
 * @returns boolean
 * @example
 * ```js
 *  is('passenger') // 乘客端
 *  is('passenger,kfpassenger') // 滴滴乘客端或花小猪客户端
 *  is('passenger.ios') // 滴滴乘客端且ios系统
 * ```
 */
export function is(strs) {
    return baseIs(strs, window.navigator.userAgent);
}
export let isHK = false;
try {
    if (is('miniprogram')) {
        isHK = !!query().isHK || Object.values(hongKongHostMap).some(hkHost => new RegExp(hkHost).test(parseURL().hostAndPath));
    }
    else {
        isHK = Object.values(hongKongHostMap).some(hkHost => new RegExp(hkHost).test(parseURL().hostAndPath));
    }
}
catch (error) {
    isHK = false;
}
export function xenv() {
    return baseXenv({
        url: window.location.href,
        userAgent: window.navigator.userAgent
    });
}
// 运行环境映射到目标环境-{init传入环境参数: [运行环境, 目标环境]
const rewriteXenvMap = {
    // 花小猪乘客业务H5在滴滴出行乘客NA中投放，采用H5登录
    'kfpassenger': ['passenger', 'h5'],
    'passenger': false,
    'driver': false,
    'kfdriver': false
};
// 重写当前运行环境 
export function rewriteXenv() {
    const rewriteXenvBranch = rewriteXenvMap[getBranch()];
    if (rewriteXenvBranch) {
        if (xenv() === rewriteXenvBranch[0]) {
            return rewriteXenvBranch[1];
            // 常规情况
        }
    }
    return xenv();
}
export const ua = parseUserAgent(window.navigator.userAgent);
// TODO:能够推导出return值，目前是any，外部需要使用类型断言
export function xenvActionFactory(api, option) {
    const _xenv = rewriteXenv();
    if (!(_xenv in option) || typeof option[_xenv] !== 'function') {
        webxError({
            type: webxErrorType.API_NOT_SUPPORT,
            msg: `当前环境${xenv}不支持${api}`
        });
    }
    return option[_xenv];
}
